import React, { useEffect, useState } from "react";
import { cnpjMask } from "../../Services/cnpjMask";
import { cpfMask } from "../../Services/cpfMask";
import { limpa_cpf_cnpj } from "../../Services/limpa_cpf_cnpj";
import { validateEmail } from "../../Services/validaEmail";
import { validateCPF } from "../../Services/validateCPF";
import { maskCell } from "../../Utils/maskCell";
import { Container, Input, Header } from "./styles";

interface Props {
  title: "NOME" | "EMAIL" | "CPF" | "CNPJ" | "FONE" | "CELULAR" | "SENHA";
  value: string;
  execute(str: string): void;
  ativo: boolean;
  disabled: boolean;
}
export function PerfilInput({ title, value, execute, ativo, disabled }: Props) {
  const [value_, setValue] = useState("");
  const [maxLength, setMaxLength] = useState(0);
  const [mask, setMak]= useState("");




  useEffect(() => {
    setValue(value);
  }, [title, value]);
  useEffect(() => {
    
    if (title == "CPF") {
      if(value_)
      setValue(cpfMask(value_));
      setMak(cpfMask('00000000000'))
      setMaxLength(14);
    }
    if (title == "CNPJ") {
      if(value_)
      setValue(cnpjMask(value_));
      setMak(cnpjMask('00000000000000'))
      setMaxLength(18);
    }
    if (title == "CELULAR") {
      if(value_)
      setValue(maskCell(value_));
      setMak(maskCell('00000000000'))
      setMaxLength(11 + 4);
    }
    if (title == "FONE") {
      if(value_)
      setValue(maskCell(value_));
      setMak(maskCell('0000000000'))
      setMaxLength(11 + 4);
    }

    if (title == "EMAIL" ) {
      if(value_)
      setValue(value_);
      setMak(maskCell('exemplo@email.com'))
      setMaxLength(256);
    }
    if(title=="NOME"){
      if(value_)
      setValue(value_);
      setMaxLength(100);
    }
    if (title == "SENHA") {
      if(value_)
      setValue(value_);
      setMaxLength(100);
    }
    execute(value_);
  }, [value_]);

  useEffect(()=>{
    setValue(value)
  },[])
 



  return (
    <Container ativo={disabled ? ativo : true}>
      <Header htmlFor={`input#${title}`}>{title}</Header>
      <Input
      maxLength={maxLength}
      placeholder={mask}
        value={value_}
        disabled={disabled}
        onChange={(ev) => {
          setValue(ev.target.value);
        
        }}
        id={`input#${title}`}
      />
     
    </Container>
  );
}
